/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useMemo } from 'react';
import { useMutation, useQuery } from '@apollo/client';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { FaArrowUpRightFromSquare } from 'react-icons/fa6';
import { FSBTable } from 'components/common/FSBTable';
import DeleteConfirmationAlert from 'components/DeleteConfirmationAlert';
import {
  DELETE_DEMAND,
  UPDATE_DEMAND_STATUS,
} from 'pages/MarketListing/MarketListingGraphQL';
import { setBidDetails } from 'actions/bidDetailAction';
import {
  MARKET_LIST_STATUS,
  forwardDemandsColumns,
} from 'pages/MarketListing/constant';
import StatusFormatter from 'components/StatusFormatter';
import {
  RECORD_DELETED_SUCCESSFULLY,
  STATUS_UPDATED_SUCCESSFULLY,
} from 'components/common/FSBToastify/types';
import Loader from 'components/common/Loader';
import { defaultDeleteFilter, showSequenceNumber } from 'utils/constants';
import { cloneDeep, isEmpty } from 'lodash';
import DownloadCSV from 'components/DownloadCSV';
import {
  EXPORTS_DEMANDS,
  FORWARD_DEMANDS_QUERY,
  FORWARD_DEMANDS_SUBSCRIPTION_QUERY,
} from 'utils/CommonGraphQL';
import { setVendorDetails } from 'actions/vendorDetailsAction';
import { role } from 'config/role';
import RBAC from 'hoc/RBAC';
import ErrorMessage from 'components/ErrorMessage';
import NoDataFound from 'components/NoDataFound';
import FilterResultBar from 'components/FilterResultBar';
import MarketListingMobileView from 'pages/MarketListing/components/MarketListingMobileView';

const ForwardDemandsTable = ({
  searchString,
  filterValue,
  handleResetFilter,
  showAdvancedSearchBar,
  selectedProductName,
}) => {
  const dispatch = useDispatch();
  const [deleteRowId, setDeleteRowId] = useState('');
  // const [updateRecordModal, setUpdateRecordModal] = useState(false);
  // const [selectedUserRow, setSelectedUserRow] = useState([]);
  const [showDeleteRecord, setDeleteRecord] = useState(false);
  const [filters, setFilters] = useState({
    filter: [
      {
        key: 'entityName',
        joinAttributeName: 'trader',
        value: searchString,
        type: 'STRING',
        op: 'LIKE_OR_NULL',
      },
      {
        key: 'status',
        value: 'ACTIVE',
        type: 'STRING',
        op: 'EQ',
      },
      {
        key: 'totalQty',
        value: 0,
        type: 'INT',
        op: 'GT',
      },
      // {
      //   key: 'demandType',
      //   value: TYPE_OF_OFFER_AND_DEMAND.FORWARD,
      //   type: 'STRING',
      //   op: 'EQ',
      // },
      {
        ...defaultDeleteFilter,
      },
    ],
    pageNo: 1,
    pageSize: 10,
    sortCol: 'createdAt',
    sortDirection: 'DESC',
  });
  // Build the product name filter for GraphQL
  const productNameFilter = useMemo(() => {
    if (!selectedProductName) return [];
    return [
      {
        key: 'name',
        value: selectedProductName,
        joinAttributeName: 'grades.subCategory.product',
        type: 'STRING',
        op: 'EQ',
      },
    ];
  }, [selectedProductName]);

  const { data, loading, error, refetch, subscribeToMore } = useQuery(
    FORWARD_DEMANDS_QUERY,
    {
      variables: {
        ...filters,
        filter: [...filters.filter, ...filterValue, ...productNameFilter],
      },
      fetchPolicy: 'network-only',
    },
  );

  const [deleteDemand] = useMutation(DELETE_DEMAND, {
    // eslint-disable-next-line no-shadow
    onCompleted: () => {
      toast.success(RECORD_DELETED_SUCCESSFULLY);
      setDeleteRowId('');
      setDeleteRecord(!showDeleteRecord);
    },
    onError: () => { },
  });

  const [updateDemandStatus] = useMutation(UPDATE_DEMAND_STATUS, {
    // eslint-disable-next-line no-shadow
    onCompleted: () => {
      toast.success(STATUS_UPDATED_SUCCESSFULLY);
    },
    onError: () => { },
  });
  // const onClickEdit = ({ row }) => {
  //   setUpdateRecordModal(true);
  //   setSelectedUserRow(row?.original);
  // };

  // const onCloseUpdatePopup = () => {
  //   setUpdateRecordModal(false);
  // };

  const toggleDeleteRecord = (id) => {
    setDeleteRecord(!showDeleteRecord);
    setDeleteRowId(id);
  };

  const onDeleteConfirmation = async () => {
    try {
      await deleteDemand({
        variables: { id: deleteRowId },
      });
    } catch (err) {
      toast.error(err);
    }
  };
  // const actionsFormatter = (cell) => {
  //   return (
  //     <ActionsFormatter
  //       isView={false}
  //       handleView={() => handleViewDetail(cell?.row?.original, 'demandType')}
  //       handleEdit={() => onClickEdit(cell)}
  //       handleDelete={() => toggleDeleteRecord(cell?.row?.original?.id)}
  //     />
  //   );
  // };

  const handleOfferStatus = async (e, cell) => {
    try {
      await updateDemandStatus({
        variables: { id: cell?.row?.original?.id, status: e.target.value },
      });
      refetch();
    } catch (err) {
      toast.error(err);
    }
  };

  const statusFormatter = (cell) => {
    return (
      <RBAC
        allowedRoles={[role.SUPER_ADMIN, role.ADMIN, role.SALES_HEAD]}
        disabled
      >
        {({ access }) => (
          <StatusFormatter
            options={MARKET_LIST_STATUS}
            defaultValue={cell?.row?.original?.status}
            handleChange={(e) => handleOfferStatus(e, cell)}
            inputDisabled={!access}
          />
        )}
      </RBAC>
    );
  };

  const handleLinkClick = (row) => {
    dispatch(
      setBidDetails({
        status: true,
        selectedBid: {
          ...row,
          bidType: 'demand',
          bidDemandType: 'FORWARD',
          filters,
        },
      }),
    );
  };

  const linkFormatter = (cell) => {
    return (
      <div
        className="text-blue-c5 fw-medium cursor-pointer d-flex align-items-center"
        onClick={() => handleLinkClick(cell?.row?.original)}
        aria-hidden
      >
        <span className="me-2 f-16">{cell?.row?.original?.id}</span>{' '}
        <FaArrowUpRightFromSquare />
      </div>
    );
  };

  const handleNameClick = (row) => {
    if (!row?.trader?.id) return;
    dispatch(
      setVendorDetails({
        status: true,
        selectedVendor: row.trader,
      }),
    );
  };
  // const nameFormatter = (cell) => {
  //   return (
  //     <div
  //       className="text-blue-c5 fw-medium cursor-pointer"
  //       onClick={() => handleNameClick(cell?.row?.original?.trader)}
  //       aria-hidden
  //     >
  //       {cell?.row?.original?.trader?.firstName}{' '}
  //       {cell?.row?.original?.trader?.lastName}
  //     </div>
  //   );
  // };

  const findIndexOfItem = (item) => {
    return forwardDemandsColumns.findIndex((itm) => itm.accessorKey === item);
  };

  forwardDemandsColumns[findIndexOfItem('status')].cell = statusFormatter;
  // forwardDemandsColumns[findIndexOfItem('actions')].cell = actionsFormatter;
  forwardDemandsColumns[findIndexOfItem('id')].cell = linkFormatter;
  forwardDemandsColumns[findIndexOfItem('SNo')].cell = (cell) =>
    showSequenceNumber(cell, filters);
  // forwardDemandsColumns[findIndexOfItem('trader')].cell = nameFormatter;

  const handlePageChange = ({ pageSize, pageNo }) => {
    setFilters({
      ...filters,
      pageNo: data?.allForwardDemands?.totalCount < pageSize ? 1 : pageNo,
      pageSize,
    });
  };
  const onSortChange = (sort) => {
    setFilters({
      ...filters,
      sortCol: sort()[0].id,
      sortDirection: sort()[0].desc ? 'DESC' : 'ASC',
    });
  };

  const sortBy = [
    filters.sortCol === null
      ? { id: null, desc: null }
      : {
        id: filters.sortCol,
        desc: filters.sortDirection === 'DESC',
      },
  ];

  useEffect(() => {
    const updatedFilter = [...filters.filter]; // Clone the filter array
    const updatedFirstFilter = { ...updatedFilter[0] }; // Clone the 0th filter object
    updatedFirstFilter.value = searchString;
    updatedFilter[0] = updatedFirstFilter; // Replace the 0th filter with the updated one
    // return { ...prevFilter, filter: updatedFilter }; // Update the filter property in the state
    refetch({ ...filters, filter: updatedFilter });
  }, [searchString]);

  const onGlobalSearch = (str) => {
    if (str) {
      setFilters((prevFilter) => {
        const updatedFilter = [...prevFilter.filter]; // Clone the filter array
        const updatedFirstFilter = { ...updatedFilter[0] }; // Clone the 0th filter object
        updatedFirstFilter.value = str;
        updatedFilter[0] = updatedFirstFilter; // Replace the 0th filter with the updated one
        return { ...prevFilter, filter: updatedFilter }; // Update the filter property in the state
      });
    }
  };

  useEffect(() => {
    const deletedObj = filters.filter.filter((val) => val.key !== 'isDeleted');
    const unsubscribe = subscribeToMore({
      document: FORWARD_DEMANDS_SUBSCRIPTION_QUERY,
      variables: { ...filters, filter: deletedObj },
      updateQuery: (prev, { subscriptionData }) => {
        const newData = cloneDeep(prev);
        const indexFound = newData.allForwardDemands.forwardDemands.findIndex(
          (val) =>
            val.id === subscriptionData.data.allForwardDemands.forwardDemand.id,
        );
        if (!prev || isEmpty(prev)) return '';
        if (!subscriptionData.data) return prev;
        if (!subscriptionData.data?.allForwardDemands?.forwardDemand)
          return prev;
        if (subscriptionData.data.allForwardDemands.action === 'CREATED') {
          const newDemand =
            subscriptionData.data.allForwardDemands.forwardDemand;
          const updatedDemands = [
            newDemand,
            ...newData.allForwardDemands.forwardDemands,
          ];

          const newTotalCount = prev.allForwardDemands.totalCount + 1;
          const newTotalPages = Math.ceil(newTotalCount / filters.pageSize);

          newData.allForwardDemands = {
            ...newData.allForwardDemands,
            totalCount: newTotalCount,
            totalPages: newTotalPages,
            forwardDemands: updatedDemands,
          };
        }
        if (subscriptionData.data.allForwardDemands.action === 'UPDATED') {
          newData.allForwardDemands.forwardDemands[indexFound] =
            subscriptionData.data.allForwardDemands.forwardDemand;
        }

        if (subscriptionData.data.allForwardDemands.action === 'DELETED') {
          const { id } = subscriptionData.data.allForwardDemands.forwardDemand; // ID of the demand to remove
          const prevDemands = prev.allForwardDemands.forwardDemands;

          const updatedDemands = prevDemands.filter((val) => val.id !== id);

          const newTotalCount = prev.allForwardDemands.totalCount - 1;
          const newTotalPages = Math.ceil(newTotalCount / filters.pageSize);

          const updatedDemandsData = {
            ...newData.allForwardDemands,
            totalCount: newTotalCount,
            totalPages: newTotalPages,
            forwardDemands: updatedDemands,
          };

          newData.allForwardDemands = updatedDemandsData;
        }

        return newData;
      },
    });

    return () => unsubscribe();
  }, []);

  if (loading) return <Loader />;
  if (error) {
    return <ErrorMessage error={error} />;
  }
  if (!data?.allForwardDemands?.forwardDemands)
    return <NoDataFound message="Demands not available" />;

  return (
    <>
      {showAdvancedSearchBar &&
        data?.allForwardDemands?.forwardDemands.length > 0 && (
          <FilterResultBar
            length={data?.allForwardDemands?.forwardDemands.length}
            type="forward demands"
            handleResetFilter={handleResetFilter}
          />
        )}
      {/* <FSBModal
        title="Edit Demands"
        closeButtonLabel=""
        confirmButtonLabel=""
        message=""
        open={updateRecordModal}
        onClose={onCloseUpdatePopup}
        toggleAlert={onCloseUpdatePopup}
        modalClass="right-drawer"
      >
        {selectedUserRow?.demandType === types.LIVE && (
          <EditLiveWrapper
            onCloseUpdatePopup={onCloseUpdatePopup}
            currentRow={selectedUserRow}
            type={OFFER_AND_DEMAND_TYPE.DEMANDTYPE}
          />
        )}
        {selectedUserRow?.demandType === types.FORWARD && (
          <EditForwardWrapper
            onCloseUpdatePopup={onCloseUpdatePopup}
            currentRow={selectedUserRow}
            type={OFFER_AND_DEMAND_TYPE.DEMANDTYPE}
          />
        )}
        {selectedUserRow?.demandType === types.FOREIGN && (
          <EditForeignWrapper
            onCloseUpdatePopup={onCloseUpdatePopup}
            currentRow={selectedUserRow}
            type={OFFER_AND_DEMAND_TYPE.DEMANDTYPE}
          />
        )}{' '}
      </FSBModal> */}
      <DeleteConfirmationAlert
        open={showDeleteRecord}
        title="Delete"
        message="Do you really want to remove this record?"
        cancelButtonLabel="Close"
        addButtonLabel="Delete"
        onConfirm={onDeleteConfirmation}
        onCancel={toggleDeleteRecord}
      />
      <DownloadCSV
        lazyQuery={EXPORTS_DEMANDS}
        filters={{
          filter: [...filters.filter, ...filterValue, ...productNameFilter],
          sortCol: filters.sortCol,
          sortDirection: filters.sortDirection,
        }}
        apiKey="exportDemands"
        fileName="ForwardDemands"
        formats={["csv", "excel"]}
        classWrapper="market-listing-download"
        positionTop="-34px"
        positionRight="0"
      />
      <MarketListingMobileView
        rows={(data && data?.allForwardDemands?.forwardDemands) || []}
        filters={filters}
        kind="demand"
        totalPages={(data && data?.allForwardDemands?.totalPages) || 0}
        currentPageNo={filters.pageNo}
        currentPageSize={filters.pageSize}
        handlePageChange={handlePageChange}
        onIdClick={handleLinkClick}
        onNameClick={handleNameClick}
        renderStatusControl={(row, index) =>
          statusFormatter({ row: { original: row, index } })
        }
      >
        <FSBTable
          data={(data && data?.allForwardDemands?.forwardDemands) || []}
          totalCount={(data && data?.allForwardDemands?.totalCount) || 0}
          totalPages={(data && data?.allForwardDemands?.totalPages) || 0}
          columns={forwardDemandsColumns}
          currentPageNo={filters.pageNo}
          pageSize={filters.pageSize}
          keyField="id"
          showSearch={false}
          showFilters
          showDelete={false}
          showPagination
          remote
          striped={false}
          hover={false}
          bordered={false}
          wrapperClass="table-responsive word-break"
          handlePageChange={handlePageChange}
          globalSearchStr={filters.filter[0].value}
          onGlobalSearch={onGlobalSearch}
          onSortChange={onSortChange}
          sorting={sortBy}
          searchPlaceholder="Search Vendors"
        />
      </MarketListingMobileView>
    </>
  );
};
export default ForwardDemandsTable;
